var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "63px",
    height: "68px",
    viewBox: "0 0 63 68",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 8,
    transform: "translate(-176.000000, -131.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ilust-VerifyPhone",
    transform: "translate(176.000000, 131.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#DEF9FD",
    cx: 31.5,
    cy: 33.5,
    r: 31.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(11.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#7FDCF4",
    x: 0,
    y: 0,
    width: 41,
    height: 68,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FBFCFD",
    x: 2,
    y: 8,
    width: 37,
    height: 48
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#1CC1EB",
    cx: 20.5,
    cy: 61.5,
    r: 3.5
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneicon);
export default __webpack_public_path__ + "static/media/phone.icon.18cb698146b39be01e85ed87ac3dbe41.svg";
export { ForwardRef as ReactComponent };